import React from 'react';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import { Specifications } from '../../../../_metronic/layout/components/basePage/insidePages/Specifications';
import { SpecificationsUIProvider } from '../../../../_metronic/layout/components/basePage/insidePages/SpecificationsUIContext';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";

const CalendarPage = ({
  initObject,
  api,
  reduxName,
  columns,
  prepareFilter,
  filterInitialValues,
  filterFields,
  haveAccess
}) => {

  return (
    <Card>
    <CardHeader title="">
      {/* <CardHeaderToolbar>
        {haveGeneralAction && <button
          type="button"
          className="btn btn-primary"
          onClick={ObjectsUIProps.newObjectButtonClick}
          disabled={!isFullAccess}
        >
          {intl.formatMessage({ id: 'MODULES.GENERAL.BUTTONNEW' })}
        </button>
        }
      </CardHeaderToolbar> */}
    </CardHeader>
    <CardBody>
    <FilterObjectsUIProvider>
      <SpecificationsUIProvider currentParentId={0} currentParentName="" initSpecification={initObject}>
        <Specifications api={api} reduxName={reduxName} columns={columns} prepareFilter={prepareFilter}
          filterInitialValues={filterInitialValues} filterFields={filterFields} haveFullAccess={false} holiday={haveAccess}/>
      </SpecificationsUIProvider>
    </FilterObjectsUIProvider>
    </CardBody>
  </Card>
    
  )
}

export default CalendarPage



